import React from "react";
import { Link } from "react-router-dom";
import { Globe, ShieldCheck, Copy, ExternalLink, Info } from "lucide-react";
import { toast } from "sonner";
import PublicHeader from "@/components/PublicHeader";
import PublicFooter from "@/components/PublicFooter";

const CREDS = { email: "admin@netkom.fr", password: "admin123" };

const Field = ({ label, value }) => {
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      toast.success(`${label} copié`);
    } catch { /* ignore */ }
  };
  return (
    <div className="flex items-center gap-2 bg-muted/50 border border-border rounded-md px-3 py-2 font-mono text-sm">
      <span className="text-muted-foreground text-xs uppercase tracking-wider mr-1">{label}</span>
      <span className="flex-1 break-all">{value}</span>
      <button onClick={copy} className="h-7 w-7 rounded hover:bg-background flex items-center justify-center" aria-label={`Copier ${label}`} data-testid={`copy-${label.toLowerCase()}`}>
        <Copy className="h-3.5 w-3.5" />
      </button>
    </div>
  );
};

export default function DemoPage() {
  return (
    <div className="min-h-screen bg-background text-foreground" data-testid="demo-page">
      <PublicHeader />

      <section className="max-w-4xl mx-auto px-6 pt-20 pb-8 text-center">
        <p className="text-xs uppercase tracking-[0.3em] text-muted-foreground mb-4">// Démo en ligne</p>
        <h1 className="text-5xl sm:text-6xl font-black tracking-tight mb-6">Essayez WiLink</h1>
        <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
          Une instance de démo complète et fonctionnelle, réinitialisée toutes les 30 minutes. Naviguez en tant qu&apos;utilisateur, ou connectez-vous au backoffice pour explorer l&apos;administration.
        </p>
      </section>

      <section className="max-w-5xl mx-auto px-6 pb-16 grid md:grid-cols-2 gap-6" data-testid="demo-cards">
        {/* Public */}
        <div className="rounded-xl border-2 border-border bg-card p-8 flex flex-col" data-testid="demo-public-card">
          <div className="h-12 w-12 rounded-lg bg-primary/10 text-primary flex items-center justify-center mb-4">
            <Globe className="h-6 w-6" />
          </div>
          <h2 className="text-2xl font-bold mb-2">Page publique</h2>
          <p className="text-muted-foreground text-sm mb-6">L&apos;interface utilisateur finale : la page d&apos;accueil que verront vos collaborateurs, avec leurs raccourcis vers les outils internes.</p>
          <ul className="text-sm space-y-2 mb-6">
            <li className="flex items-start gap-2"><span className="text-primary mt-1">▸</span> Grille d&apos;icônes interactives</li>
            <li className="flex items-start gap-2"><span className="text-primary mt-1">▸</span> Recherche instantanée</li>
            <li className="flex items-start gap-2"><span className="text-primary mt-1">▸</span> Filtres par catégorie</li>
            <li className="flex items-start gap-2"><span className="text-primary mt-1">▸</span> Annonces en haut de page</li>
          </ul>
          <a
            href="/demo/portal"
            className="h-12 px-5 rounded-md bg-primary text-primary-foreground hover:bg-primary/90 font-medium inline-flex items-center justify-center gap-2 mt-auto"
            data-testid="demo-open-public"
          >
            <ExternalLink className="h-4 w-4" /> Accéder à la page publique
          </a>
        </div>

        {/* Admin */}
        <div className="rounded-xl border-2 border-primary bg-card p-8 flex flex-col shadow-lg" data-testid="demo-admin-card">
          <div className="h-12 w-12 rounded-lg bg-primary/10 text-primary flex items-center justify-center mb-4">
            <ShieldCheck className="h-6 w-6" />
          </div>
          <h2 className="text-2xl font-bold mb-2">Backoffice administrateur</h2>
          <p className="text-muted-foreground text-sm mb-4">L&apos;interface d&apos;administration pour configurer le portail, gérer les liens, catégories, annonces, et bien plus.</p>

          <div className="space-y-2 mb-5">
            <Field label="Email" value={CREDS.email} />
            <Field label="Mot de passe" value={CREDS.password} />
          </div>

          <div className="bg-yellow-50 dark:bg-yellow-950/30 border border-yellow-200 dark:border-yellow-900 rounded-md p-3 text-xs flex gap-2 mb-5" data-testid="demo-warning">
            <Info className="h-4 w-4 text-yellow-600 dark:text-yellow-400 shrink-0 mt-0.5" />
            <span>Cette démo est partagée et réinitialisée régulièrement. Toute donnée que vous saisirez sera effacée.</span>
          </div>

          <a
            href="/admin/login"
            className="h-12 px-5 rounded-md bg-primary text-primary-foreground hover:bg-primary/90 font-medium inline-flex items-center justify-center gap-2 mt-auto"
            data-testid="demo-open-admin"
          >
            <ExternalLink className="h-4 w-4" /> Accéder au backoffice
          </a>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-6 pb-16 text-center">
        <p className="text-sm text-muted-foreground">
          Prêt à avoir votre propre instance ? <Link to="/tarifs" className="text-primary font-medium hover:underline">Commandez WiLink à 69€</Link>
        </p>
      </section>

      <PublicFooter />
    </div>
  );
}
